import templateUrl from './bind-html.html';

export const bindhtmlComponent = {
	bindings: {
		content: '<',
		isClampText: '@'
	},
	templateUrl,
	controller: class BindhtmlComponent {
		constructor($sce, $parse) {
			'ngInject';
			this.content = '';
			this.$sce = $sce;
			this.$parse = $parse;
		}
		$onInit() {
			this.content = this.$sce.trustAsHtml(this.content);
			this._isClampText = this.$parse(this.isClampText || 'false')(false);
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/bind-html/bind-html.component.js